// extracted by mini-css-extract-plugin
export default {"banner":"xE_MdPG1fpbF8xuxd9zr","downloadLink":"hdnvazXyQ5VIBWKDHbAe"};